<template>
  <div id="app">
    <header class="header px-3 py-4">
      <b-row class="px-4" align="left">
        <b-col sm="auto" class="pr-0">
          <router-link to="/"><img class="logo" alt="Logo Británico" :src="require('./assets/logo.svg')"/></router-link>
        </b-col>
        <b-col class="pl-0">
          <h1 class="title text-center">Gestión de Certificados y Constancias</h1>
        </b-col>
      </b-row>
      
    </header>
    <main class="main d-flex align-items-stretch">
      <Sidebar class="sidebar flex-shrink-0"/>
      <router-view class="flex-grow-1"/> 
    </main>
  </div>
</template>

<script>
export default {
  components: {
    Sidebar: () => import(/* webpackChunkName: "general" */ './components/Sidebar.vue')
  },
  name: 'App'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');

@font-face {
  font-family: 'ProximaNova-Regular';
  src: url('assets/fonts/PROXIMANOVA-REGULAR_1.woff'); 
}

@font-face {
  font-family: 'ProximaNova-Bold';
  src: url('assets/fonts/PROXIMANOVA-BOLD_1.woff'); 
}

@font-face {
  font-family: 'ProximaNova-Semibold';
  src: url('assets/fonts/PROXIMANOVA-SEMIBOLD_1.woff'); 
}

#app {
  font-family: 'ProximaNova-Regular', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #4f5e6d;
}

.title {
  color: #034087;
  font-family: 'ProximaNova-Bold';
  font-size: 36px;
}

.title::before {
  content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: #40D7D7;
    width: 70px;
    height: 2px;
}

.logo {
  width: 180px;
}

.header {
  border-bottom: 1px solid #EFEDED;
  height: 114px;
}
.sidebar {
  width: 217px;
  border-right: 1px solid #EFEDED;
  background-color: #ffffff;
}

.main{
  min-height: calc(100vh - 114px);
  background-color: #F6F6F6;
}
</style>
